import { useRef, useEffect } from 'react'
import { useMount } from 'components/hooks'

function useEffectOnce(meetCondition, func, hooks) {
  const isDone = useRef(false)
  const funcRef = useRef(func)
  const hooksRef = useRef(hooks)

  useEffect(() => void (funcRef.current = func), [func])
  useEffect(() => void (hooksRef.current = hooks), [hooks])

  useMount(() => {
    const onMount = hooksRef.current?.onMount,
      onUnmount = hooksRef.current?.onUnmount;
    if (onMount) onMount()
    return () => {
      if (onUnmount) onUnmount(isDone.current)
    }
  })

  useEffect(() => {
    const callback = funcRef.current,
      onDone = hooksRef.current?.onDone;

    if (!isDone.current && meetCondition && funcRef.current) {
      isDone.current = true
      if (callback) callback()
      if (onDone) onDone()
    }
  }, [meetCondition])
}

export default useEffectOnce